document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     DREAM FACTORY BEDS
     HEADBOARD CONFIGURATOR
  ========================================================= */

  const headboardHost =
    document.getElementById('headboard-upsell-card');

  if (!headboardHost) return;


  /* =========================================================
     STATE
  ========================================================= */

  let allHeadboards = [];
  let selectedHeadboardData = null;


  /* =========================================================
     CREATE INLINE HEADBOARD PANEL
  ========================================================= */

  const headboardPanel =
    document.createElement('div');

  headboardPanel.className =
    'dfb-headboard-panel';

  headboardPanel.innerHTML = `
    <div class="dfb-headboard-panel-content">
      Loading headboards...
    </div>
  `;

  headboardHost.insertAdjacentElement(
    'afterend',
    headboardPanel
  );

  const content =
    headboardPanel.querySelector(
      '.dfb-headboard-panel-content'
    );


  /* =========================================================
     STYLES
  ========================================================= */

  const styles =
    document.createElement('style');

  styles.textContent = `

    .dfb-headboard-panel {
      display:none;
      width:100%;
      background:#fff;
      margin:0;
      padding:0;
    }

    .dfb-headboard-panel.active {
      display:block;
    }

    .dfb-headboard-panel-content {
      padding-top:14px;
    }


    /* HEADBOARD CARD */

    .dfb-headboard-product {
      display:flex;
      align-items:center;
      gap:14px;

      width:100%;

      box-sizing:border-box;

      padding:14px;

      margin-bottom:10px;

      background:#FFF8F2;

      border:1px solid rgba(0,0,0,.09);
      border-radius:14px;
    }


    /* IMAGE */

    .dfb-headboard-thumb {
      width:86px;
      height:86px;

      flex:0 0 86px;

      display:flex;
      align-items:center;
      justify-content:center;

      background:#fff;

      border-radius:10px;

      overflow:hidden;
    }

    .dfb-headboard-thumb img {
      width:100%;
      height:100%;

      object-fit:contain;
    }


    /* DETAILS */

    .dfb-headboard-product-info {
      flex:1;
      min-width:0;
    }

    .dfb-headboard-product-title {
      margin:0 0 4px;

      color:#3f3f3f;

      font-size:16px;
      line-height:1.2;
      font-weight:700;
    }

    .dfb-headboard-match {
      margin-bottom:5px;

      color:#666;

      font-size:12px;
      line-height:1.2;
    }

    .dfb-headboard-product-price {
      color:#3f3f3f;

      font-size:16px;
      font-weight:700;
    }


    /* BUTTONS */

    .dfb-headboard-product-buttons {
      display:flex;
      flex-wrap:wrap;

      gap:6px;

      margin-top:8px;
    }

    .dfb-headboard-details-btn,
    .dfb-headboard-add-btn {

      min-height:34px;

      padding:7px 12px;

      border-radius:999px;

      font-family:inherit;

      font-size:12px;
      font-weight:700;

      cursor:pointer;
    }

    .dfb-headboard-details-btn {
      border:0;

      background:#000;
      color:#fff;
    }

    .dfb-headboard-add-btn {
      border:0;

      background:#C2A46F;
      color:#fff;
    }

    .dfb-headboard-add-btn.added {
      background:#2e7d32;
    }


    /* DETAILS */

    .dfb-headboard-product-details {
      display:none;

      width:100%;

      margin-top:12px;
      padding-top:12px;

      border-top:1px solid rgba(0,0,0,.08);

      color:#444;

      font-size:13px;
      line-height:1.45;
    }

    .dfb-headboard-product-details.active {
      display:block;
    }


    /* CARD WRAPPER FOR DETAILS */

    .dfb-headboard-card-wrap {
      width:100%;

      box-sizing:border-box;

      margin-bottom:10px;

      background:#FFF8F2;

      border:1px solid rgba(0,0,0,.09);
      border-radius:14px;

      overflow:hidden;
    }

    .dfb-headboard-card-wrap
    .dfb-headboard-product {
      margin:0;

      border:0;
      border-radius:0;
    }

    .dfb-headboard-card-wrap
    .dfb-headboard-product-details {
      padding:12px 14px 14px;
    }


    /* MESSAGE */

    .dfb-headboard-message {
      padding:18px 0;

      color:#555;

      font-size:14px;
    }


    @media screen and (max-width:749px) {

      .dfb-headboard-product {
        padding:11px;
        gap:10px;
      }

      .dfb-headboard-thumb {
        width:72px;
        height:72px;

        flex-basis:72px;
      }

      .dfb-headboard-product-title {
        font-size:14px;
      }

      .dfb-headboard-product-price {
        font-size:15px;
      }

      .dfb-headboard-details-btn,
      .dfb-headboard-add-btn {
        padding:6px 9px;

        font-size:11px;
      }

    }

  `;

  document.head.appendChild(styles);


  /* =========================================================
     HELPERS
  ========================================================= */

  function cleanText(value) {

    return String(value || '')
      .toLowerCase()
      .replace(/[-_]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }


  function escapeHtml(value) {

    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }


  function canonicalSize(text) {

    const s = cleanText(text);

    if (
      s.includes('2ft6') ||
      s.includes('2 ft 6') ||
      s.includes('75cm')
    ) return 'small_single';

    if (
      s.includes('4ft6') ||
      s.includes('4 ft 6') ||
      s.includes('135cm')
    ) return 'double';

    if (
      s.includes('4ft') ||
      s.includes('4 ft') ||
      s.includes('120cm')
    ) return 'small_double';

    if (
      s.includes('3ft') ||
      s.includes('3 ft') ||
      s.includes('90cm')
    ) return 'single';

    if (
      s.includes('5ft') ||
      s.includes('5 ft') ||
      s.includes('150cm')
    ) return 'king';

    if (
      s.includes('6ft') ||
      s.includes('6 ft') ||
      s.includes('180cm')
    ) return 'super_king';


    if (s.includes('super king'))
      return 'super_king';

    if (s.includes('small single'))
      return 'small_single';

    if (s.includes('small double'))
      return 'small_double';

    if (s.includes('king'))
      return 'king';

    if (s.includes('double'))
      return 'double';

    if (s.includes('single'))
      return 'single';


    return '';
  }


  function canonicalColour(text) {

    const s = cleanText(text);

    const colours = [
      'cream',
      'mink',
      'pink',
      'silver',
      'charcoal',
      'gold',
      'green',
      'blue',
      'black'
    ];

    for (const colour of colours) {

      if (s.includes(colour)) {

        return colour;
      }
    }

    return '';
  }


  /* =========================================================
     GET SELECTED BED SIZE
  ========================================================= */

  function getSelectedBedSize() {

    /* SELECTS */

    const selects =
      document.querySelectorAll('select');

    for (const select of selects) {

      const option =
        select.options[
          select.selectedIndex
        ];

      if (!option) continue;

      const text =
        option.text || option.value || '';

      const size =
        canonicalSize(text);

      if (size) return size;
    }


    /* CHECKED RADIOS */

    const checked =
      document.querySelectorAll(
        'input[type="radio"]:checked'
      );

    for (const input of checked) {

      const label =
        document.querySelector(
          `label[for="${input.id}"]`
        );

      const text =
        (
          label?.innerText ||
          input.value ||
          ''
        );

      const size =
        canonicalSize(text);

      if (size) return size;
    }


    return '';
  }


  /* =========================================================
     GET SELECTED BED COLOUR
  ========================================================= */

  function getSelectedBedColour() {

    /* SELECTS */

    const selects =
      document.querySelectorAll('select');

    for (const select of selects) {

      const option =
        select.options[
          select.selectedIndex
        ];

      if (!option) continue;

      const text =
        option.text || option.value || '';

      const colour =
        canonicalColour(text);

      if (colour) return colour;
    }


    /* CHECKED SWATCH / RADIO INPUTS */

    const checked =
      document.querySelectorAll(
        'input[type="radio"]:checked'
      );

    for (const input of checked) {

      const label =
        document.querySelector(
          `label[for="${input.id}"]`
        );

      const text = [
        input.value,
        input.name,
        input.getAttribute('data-option-value'),
        input.getAttribute('data-value'),
        label?.innerText,
        label?.getAttribute('title'),
        label?.getAttribute('aria-label')
      ].join(' ');

      const colour =
        canonicalColour(text);

      if (colour) return colour;
    }


    return '';
  }


  /* =========================================================
     PRODUCT IMAGE
  ========================================================= */

  function getProductImage(product) {

    if (
      !product.images ||
      !product.images.length
    ) return '';

    return typeof product.images[0] === 'string'
      ? product.images[0]
      : product.images[0].src;
  }


  /* =========================================================
     PRICE
  ========================================================= */

  function priceToNumber(value) {

    return parseFloat(value) || 0;
  }


  /* =========================================================
     OPEN / CLOSE
  ========================================================= */

  function openHeadboards() {

    headboardPanel.classList.add(
      'active'
    );
  }


  function closeHeadboards() {

    headboardPanel.classList.remove(
      'active'
    );
  }


  /* =========================================================
     LOAD THE FIVE HEADBOARDS
  ========================================================= */

  function loadHeadboards() {

    content.innerHTML = `
      <div class="dfb-headboard-message">
        Loading headboards...
      </div>
    `;


    fetch(
      '/collections/bed-base-headboard-add-ons/products.json?limit=20'
    )

      .then(function(response) {

        if (!response.ok) {

          throw new Error(
            'Could not load headboards'
          );
        }

        return response.json();
      })


      .then(function(data) {

        allHeadboards =
          data.products || [];

        renderHeadboards();
      })


      .catch(function() {

        content.innerHTML = `
          <div class="dfb-headboard-message">
            Could not load headboards.
          </div>
        `;
      });
  }


  /* =========================================================
     RENDER MATCHING SIZE + COLOUR
  ========================================================= */

  function renderHeadboards() {

    const selectedSize =
      getSelectedBedSize();

    const selectedColour =
      getSelectedBedColour();


    if (!selectedSize) {

      content.innerHTML = `
        <div class="dfb-headboard-message">
          Please choose your bed size first.
        </div>
      `;

      return;
    }


    if (!selectedColour) {

      content.innerHTML = `
        <div class="dfb-headboard-message">
          Please choose your bed colour first.
        </div>
      `;

      return;
    }


    let html = '';

    let productCount = 0;


    allHeadboards.forEach(
      function(product) {

        const matchingVariant =
          product.variants.find(
            function(variant) {

              const variantText = [

                variant.title,

                variant.option1,

                variant.option2,

                variant.option3

              ]

                .filter(Boolean)

                .join(' ');


              const variantSize =
                canonicalSize(
                  variantText
                );


              const variantColour =
                canonicalColour(
                  variantText
                );


              return (

                variantSize ===
                  selectedSize &&

                variantColour ===
                  selectedColour

              );
            }
          );


        if (!matchingVariant) {

          return;
        }


        productCount++;


        const image =
          getProductImage(product);


        const price =
          priceToNumber(
            matchingVariant.price
          );


        const safeTitle =
          escapeHtml(product.title);


        const safeImage =
          escapeHtml(image);


        const displayColour =
          selectedColour
            .charAt(0)
            .toUpperCase() +
          selectedColour.slice(1);


        html += `

          <div
            class="dfb-headboard-card-wrap"
            data-id="${matchingVariant.id}"
          >

            <div class="dfb-headboard-product">

              <div class="dfb-headboard-thumb">

                ${
                  image

                  ? `
                    <img
                      src="${safeImage}"
                      alt="${safeTitle}"
                    >
                  `

                  : ''
                }

              </div>


              <div class="dfb-headboard-product-info">

                <div class="dfb-headboard-product-title">
                  ${safeTitle}
                </div>


                <div class="dfb-headboard-match">
                  Matching ${displayColour}
                </div>


                <div class="dfb-headboard-product-price">
                  £${price.toFixed(2)}
                </div>


                <div class="dfb-headboard-product-buttons">

                  <button
                    type="button"
                    class="dfb-headboard-details-btn"
                  >
                    More details
                  </button>


                  <button
                    type="button"
                    class="dfb-headboard-add-btn"
                  >
                    Add Headboard
                  </button>

                </div>

              </div>

            </div>


            <div
              class="dfb-headboard-product-details"
            >
              ${product.body_html || ''}
            </div>

          </div>

        `;
      }
    );


    if (productCount === 0) {

      html = `
        <div class="dfb-headboard-message">

          No matching headboards were found
          for this bed size and colour.

        </div>
      `;
    }


    content.innerHTML =
      html;


    attachHeadboardInteractions();
  }


  /* =========================================================
     CARD ACTIONS
  ========================================================= */

  function attachHeadboardInteractions() {

    content
      .querySelectorAll(
        '.dfb-headboard-card-wrap'
      )

      .forEach(
        function(card) {


          const detailsButton =
            card.querySelector(
              '.dfb-headboard-details-btn'
            );


          const details =
            card.querySelector(
              '.dfb-headboard-product-details'
            );


          const addButton =
            card.querySelector(
              '.dfb-headboard-add-btn'
            );


          /* MORE DETAILS */

          if (
            detailsButton &&
            details
          ) {

            detailsButton.addEventListener(
              'click',
              function() {

                details.classList.toggle(
                  'active'
                );


                this.innerText =
                  details.classList.contains(
                    'active'
                  )

                  ? 'Hide details'

                  : 'More details';
              }
            );

          }


          /* ADD HEADBOARD */

          if (addButton) {

            addButton.addEventListener(
              'click',
              function() {


                const variantId =
                  card.dataset.id;


                const title =
                  card.querySelector(
                    '.dfb-headboard-product-title'
                  )?.innerText || '';


                const price =
                  card.querySelector(
                    '.dfb-headboard-product-price'
                  )?.innerText || '';


                const image =
                  card.querySelector(
                    '.dfb-headboard-thumb img'
                  )?.src || '';


                const selectedData = {

                  id:
                    variantId,

                  title:
                    title,

                  price:
                    price,

                  image:
                    image

                };


                addButton.innerText =
                  'Adding...';


                addButton.disabled =
                  true;


                fetch(
                  '/cart/add.js',
                  {

                    method:
                      'POST',

                    headers: {
                      'Content-Type':
                        'application/json'
                    },

                    body:
                      JSON.stringify({

                        id:
                          variantId,

                        quantity:
                          1

                      })

                  }
                )


                  .then(
                    function(response) {

                      if (!response.ok) {

                        throw new Error(
                          'Could not add headboard'
                        );
                      }

                      return response.json();
                    }
                  )


                  .then(
                    function() {


                      addButton.innerText =
                        'Added ✓';


                      addButton.classList.add(
                        'added'
                      );


                      showSelectedHeadboard(
                        selectedData
                      );


                      document.dispatchEvent(
                        new CustomEvent(
                          'cart:refresh'
                        )
                      );


                      document.dispatchEvent(
                        new CustomEvent(
                          'cart:open'
                        )
                      );


                      setTimeout(
                        function() {

                          closeHeadboards();

                        },
                        400
                      );

                    }
                  )


                  .catch(
                    function() {

                      addButton.innerText =
                        'Add Headboard';

                      addButton.disabled =
                        false;
                    }
                  );

              }
            );

          }

        }
      );
  }


  /* =========================================================
     SHOW SELECTED HEADBOARD
  ========================================================= */

  function showSelectedHeadboard(data) {

    selectedHeadboardData =
      data;


    const defaultEl =
      document.getElementById(
        'headboard-addon-default'
      );


    const selectedEl =
      document.getElementById(
        'headboard-addon-selected'
      );


    const titleEl =
      document.getElementById(
        'selected-headboard-title'
      );


    const priceEl =
      document.getElementById(
        'selected-headboard-price'
      );


    const imageEl =
      document.getElementById(
        'selected-headboard-img'
      );


    if (
      !defaultEl ||
      !selectedEl
    ) return;


    if (titleEl) {

      titleEl.innerText =
        data.title || '';
    }


    if (priceEl) {

      priceEl.innerText =
        data.price || '';
    }


    if (imageEl) {

      imageEl.src =
        data.image || '';
    }


    defaultEl.style.display =
      'none';


    selectedEl.style.display =
      'block';
  }


  /* =========================================================
     RESET HEADBOARD
  ========================================================= */

  function resetHeadboard() {

    selectedHeadboardData =
      null;


    const defaultEl =
      document.getElementById(
        'headboard-addon-default'
      );


    const selectedEl =
      document.getElementById(
        'headboard-addon-selected'
      );


    const titleEl =
      document.getElementById(
        'selected-headboard-title'
      );


    const priceEl =
      document.getElementById(
        'selected-headboard-price'
      );


    if (selectedEl) {

      selectedEl.style.display =
        'none';
    }


    if (defaultEl) {

      defaultEl.style.display =
        'block';
    }


    if (titleEl) {

      titleEl.innerText =
        '';
    }


    if (priceEl) {

      priceEl.innerText =
        '';
    }


    closeHeadboards();
  }


  /* =========================================================
     MAIN HEADBOARD BUTTONS
  ========================================================= */

  document.addEventListener(
    'click',
    function(event) {


      const mainButton =
        event.target.closest(
          '.headboard-addon-button'
        );


      const changeButton =
        event.target.closest(
          '.headboard-addon-change'
        );


      const removeButton =
        event.target.closest(
          '.headboard-addon-remove'
        );


      /* CHANGE */

      if (changeButton) {

        event.preventDefault();

        loadHeadboards();

        openHeadboards();

        return;
      }


      /* REMOVE */

      if (removeButton) {

        event.preventDefault();


        if (
          selectedHeadboardData &&
          selectedHeadboardData.id
        ) {

          fetch(
            '/cart/change.js',
            {

              method:'POST',

              headers:{
                'Content-Type':
                  'application/json'
              },

              body:
                JSON.stringify({

                  id:
                    selectedHeadboardData.id,

                  quantity:
                    0

                })

            }
          )

          .then(function() {

            document.dispatchEvent(
              new CustomEvent(
                'cart:refresh'
              )
            );

          });

        }


        resetHeadboard();

        return;
      }


      /* DEFAULT BUTTON */

      if (!mainButton) return;


      event.preventDefault();


      if (
        headboardPanel.classList.contains(
          'active'
        )
      ) {

        closeHeadboards();

        return;
      }


      loadHeadboards();

      openHeadboards();

    }
  );

});